import { useForm } from 'react-hook-form';
import { RegularText } from '../../../../../../utils/typography/BaseText';
import { useState } from 'react';
import CustomInput from '../../../../../../ui/components/CustomInput';

function CompleteBooking() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  return (
    <main className="mx-3 lg:mx-[60px] mt-4 pt-36 lg:pt-28">
      <section>
        <h1 className="font-semibold text-xl md:text-3xl">
          Complete your booking
        </h1>
        <RegularText>
          *Please note your name must be the same as it appears on your
          government issued ID.
        </RegularText>
      </section>
      <section className="grid gap-10 md:grid-cols-3 my-10">
        <div className="border border-slate-200 rounded-lg py-6 md:py-6 md:px-8 px-5 md:col-span-2 ">
          <div className="my-3 text-sm font-normal">
            <p>Guest Information</p>
          </div>
          <form>
            <div className="grid my-3 gap-3 md:grid-cols-3">
              <CustomInput
                // width=""
                className=""
                id="firstName"
                label="First name"
                option={register('firstName', {
                  required: 'First name is required',
                })}
                // error={errors.email}
              />
              <CustomInput
                // width=""
                className="md:col-span-2"
                id="lastName"
                label="Last name"
                option={register('lastName', {
                  required: 'Last name is required',
                })}
                // error={errors.email}
              />
            </div>
            <div className="grid my-3 gap-3 md:grid-cols-3">
              <CustomInput
                // width=""
                className=""
                id="country"
                label="Country"
                option={register('country', {
                  required: 'Country is required',
                })}
                // error={errors.email}
              />
              <CustomInput
                // width=""
                className="md:col-span-2"
                id="city"
                label="City"
                option={register('city', {
                  required: 'City is required',
                })}
                // error={errors.email}
              />
            </div>
            <div className="grid my-3 gap-3 md:grid-cols-1">
              <CustomInput
                as="textarea"
                // width=""
                placeholder="Address"
                className=""
                id="address"
                label="Address"
                option={register('address', {
                  required: 'Address is required',
                })}
                // error={errors.email}
              />
            </div>
          </form>
        </div>
        <div className="border border-slate-200 rounded-lg py-10 px-5  ">
          picture
        </div>
      </section>
    </main>
  );
}

export default CompleteBooking;
